import { Button, ButtonProps } from 'components';
import styles from './DetailsButton.module.scss'

type DetailsButtonProps = {
    url: string
} | ButtonProps;

const DetailsButton = (props: DetailsButtonProps) => (
    <Button
        fillMode="flat"
        themeColor="secondary"
        className={styles.button}
        {...props}
    >
        <b>VIEW DETAILS</b>
    </Button>
);
export default DetailsButton;